/* eslint-disable @typescript-eslint/naming-convention */
import { ParameterInfos } from 'ut-business/parameter';

export const calibrationParameters: Record<string, ParameterInfos> = {
  Calibration_ZoneStart: {
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    sourceUnit: 'm',
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
    },
  },
  Calibration_ZoneEnd: {
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    sourceUnit: 'm',
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
    },
  },
  Calibration_Reference_Amplitude: {
    metric: {
      unit: '%',
      defaultStep: 1,
      steps: [
        1,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    imperial: {
      unit: '%',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    sourceUnit: '%',
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
    },
  },
  Calibration_Tolerance: {
    metric: {
      unit: '%',
      defaultStep: 1,
      steps: [
        1,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    imperial: {
      unit: '%',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    sourceUnit: '%',
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
    },
  },
  Calibration_GainTotal: {
    metric: {
      unit: 'dB',
      decimals: 1,
    },
    imperial: {
      unit: 'dB',
      decimals: 1,
    },
  },
  Calibration_GainOffset: {
    metric: {
      unit: 'dB',
      decimals: 1,
    },
    imperial: {
      unit: 'dB',
      decimals: 1,
    },
  },
  Calibration_MinBeam: {
    metric: {
      unit: '',
      limit: {
        min: 0,
        max: 255 - 1,
      },
      defaultStep: 1,
      steps: [
        1,
      ],
    },
    imperial: {
      unit: '',
      limit: {
        min: 0,
        max: 255 - 1,
      },
      defaultStep: 1,
      steps: [
        1,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
    },
  },
  Calibration_MaxBeam: {
    metric: {
      unit: '',
      limit: {
        min: 0 + 1,
        max: 255,
      },
      defaultStep: 1,
      steps: [
        1,
      ],
    },
    imperial: {
      unit: '',
      limit: {
        min: 0 + 1,
        max: 255,
      },
      defaultStep: 1,
      steps: [
        1,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
    },
  },
};
